import React from "react";
function About(){
    return(
        <div>About em construção</div>
    )
}
export default About